import { useSelector } from 'react-redux';
import getConfiguration from 'store/app/selector/getConfiguration';
import globalVars from 'utils/globalVars';

const TransferConfiguration = () => {
  const configuration = useSelector(getConfiguration);
  globalVars.configuration = configuration;
  return null;
};

export default TransferConfiguration;
